import * as angular from 'angular';
import { config } from 'angular/utils/config';
import { UtilService } from 'app/_services/util.service';
import { TsoNotificationResource } from 'app/tso-notifications/tso-notification.resource';

type TsoNotificationDtoForViewModel = TsoNotificationDto & {
    _pendingMarkedAsProcessed: boolean;
};

class TsoNotificationsComponentCtrl implements ng.IController {
    private static readonly MILLIS_TO_KEEP_READ_NOTIFICATION_PENDING = 5000;

    public itemsPerPage: number;
    public tsoNotifications: TsoNotificationDto[];
    public loadingError: boolean;
    public loadingData: boolean;
    public showAllTypes: boolean;
    public isOverviewPage: boolean;
    public notificationsHaveBeenAvailableInitially: boolean;
    /** Currently there are no gas day effective notifications, but let's just keep this feature alive. */
    public notificationTypesEffectiveOnNextGasDay: TsoNotificationType[] = [];
    public stageConfig = config;
    public appBaseUrl = config.appBaseUrl;

    constructor(
        private tsoNotificationResource: TsoNotificationResource,
        private $timeout: ng.ITimeoutService,
        private utilService: UtilService
    ) {}

    $onInit() {}

    public markAsProcessed(notificationId: number): void {
        (
            this.tsoNotifications.find(
                (notif) => notif.id === notificationId
            ) as TsoNotificationDtoForViewModel
        )._pendingMarkedAsProcessed = !this.isOverviewPage;

        this.tsoNotificationResource.markAsProcessed(
            notificationId,
            () => {
                if (this.isOverviewPage) {
                    let notification = this.tsoNotifications.find(
                        (notif) => notif.id === notificationId
                    );
                    notification.readByUser = true;
                    this.loadingError = false;
                    return true;
                } else {
                    this.$timeout(() => {
                        return this.tsoNotifications.splice(
                            this.tsoNotifications.findIndex(
                                (notif) => notif.id === notificationId
                            ),
                            1
                        );
                    }, TsoNotificationsComponentCtrl.MILLIS_TO_KEEP_READ_NOTIFICATION_PENDING);
                    this.loadingError = false;
                }
            },
            () => (this.loadingError = true)
        );
    }

    public filterForGasDayValidity(): ng.IFilterFilterPredicateFunc<TsoNotificationDtoForViewModel> {
        return (
            value: TsoNotificationDtoForViewModel,
            index: number,
            array: TsoNotificationDtoForViewModel[]
        ): boolean => {
            if (
                this.notificationTypesEffectiveOnNextGasDay.indexOf(
                    value.type
                ) === -1
            ) {
                return true;
            }

            return this.utilService.isGasDayEffective(
                new Date(value.changedAt as string).getTime()
            );
        };
    }

    /**TODO this is only a workaround until the actual bundle overview is persent and the notifications will be disabled again*/
    public filterForBundleRelatedNotificationsOnly(): ng.IFilterFilterPredicateFunc<TsoNotificationDtoForViewModel> {
        return (value: TsoNotificationDtoForViewModel): boolean => {
            if (this.showAllTypes) {
                return true;
            }

            if (
                value.type === 'BUNDLE_CREATION' ||
                value.type === 'BUNDLE_CHANGE' ||
                value.type === 'BUNDLE_DELETION_CONFIRMED' ||
                value.type === 'BUNDLE_CHANGE_CONFIRMED' ||
                value.type === 'BUNDLE_CHANGE_REJECTED'
            ) {
                return true;
            }

            return false;
        };
    }
}

angular.module('app').component('pkpTsoNotifications', {
    controller: TsoNotificationsComponentCtrl,
    template: require('app/tso-notifications/tso-notifications.component.html'),
    bindings: {
        tsoNotifications: '<',
        loadingData: '<',
        loadingError: '<',
        notificationsHaveBeenAvailableInitially: '<',
        itemsPerPage: '<',
        showAllTypes: '<',
        isOverviewPage: '<'
    }
});
